import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="py-8 px-4 border-t" style={{ backgroundColor: '#ffffff', borderColor: '#e5e5e5' }}>
      <div className="max-w-6xl mx-auto text-center">
        <div className="flex flex-wrap items-center justify-center gap-4 text-xs" style={{ color: '#999' }}>
          <button
            onClick={() => navigate('/terms')}
            className="hover:underline"
          >
            Terms
          </button>
          <span>|</span>
          <button
            onClick={() => navigate('/privacy')}
            className="hover:underline"
          >
            Privacy
          </button>
          <span>|</span>
          <button
            onClick={() => navigate('/disclaimer')}
            className="hover:underline"
          >
            Disclaimer
          </button>
          <span>|</span>
          <button
            onClick={() => navigate('/refunds')}
            className="hover:underline"
          >
            Refunds
          </button>
        </div>
        <p className="mt-4 text-xs" style={{ color: '#ccc' }}>
          © {new Date().getFullYear()} The Morning Method. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
